import { render, staticRenderFns } from "./DText.vue?vue&type=template&id=9b56faae"
import script from "./DText.vue?vue&type=script&lang=ts"
export * from "./DText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports